import React, { FC, useEffect, useState } from 'react'
import styles from './CheckboxListFacet.module.scss'
import SearchIcon from 'svg/search-icon.svg'
import ClearIcon from 'svg/SA/close-x-small.svg'
import useQA from 'hooks/useQA'
import debounce from 'lib/debounce'

const searchDebounce = debounce()

type FilterFacetTextProps = {
  onSearch: (query: string) => void
  placeholder?: string
}

const FilterFacetText: FC<FilterFacetTextProps> = ({ onSearch, placeholder }) => {
  const { testId } = useQA()
  const [query, setQuery] = useState<string>('')

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value)
  }

  const handleClearInput = () => {
    setQuery('')
  }

  useEffect(() => {
    searchDebounce(() => {
      onSearch(query)
    }, 500)
  }, [query])

  return (
    <div className={styles.searchField} {...testId(`search-facet-${placeholder}`)}>
      <div className={styles.searchIconBox}>
        <SearchIcon />
      </div>
      <input value={query} onChange={handleChange} placeholder={placeholder} />
      {query !== '' && (
        <div className={styles.clearInputBox} onClick={handleClearInput}>
          <ClearIcon />
        </div>
      )}
    </div>
  )
}

export default FilterFacetText
